import { InjectionToken } from '@angular/core';

export const SSR_Auth_Token = new InjectionToken<boolean>('SSR_Auth_Token');
